import { env } from '@/shared/config';

import type { Telegram, WebApp } from './types';

/**
 * Заглушка Telegram для запуска в обычном браузере.
 *
 * Работает только в dev и только если задан `VITE_TG_MOCK_INIT_DATA`.
 * Строку генерирует `pnpm tg:init-data` — подпись это HMAC на ключе из
 * токена бота, и у разработчика токен есть. Копировать её с устройства
 * не нужно: `auth_date` протухает за сутки, проще перевыпустить.
 *
 * E2E-тесты ставят свою заглушку через `page.addInitScript` и сюда не ходят.
 */
export function installTelegramMock(): void {
  if (!env.isDev || !env.tgMockInitData) return;
  // Официальный скрипт telegram-web-app.js подключается всегда (см.
  // app/index.html) и вне настоящего Telegram сам создаёт window.Telegram.WebApp
  // с пустым initData — проверка на само наличие объекта эту заглушку не заметит.
  if (window.Telegram?.WebApp.initData) return;

  const noop = (): void => undefined;
  const chain =
    <T>(self: T) =>
    () =>
      self;

  const haptic = {
    impactOccurred: () => haptic,
    notificationOccurred: () => haptic,
    selectionChanged: () => haptic,
  };

  const button = {
    isVisible: false,
    show: chain({} as never),
    hide: chain({} as never),
    onClick: chain({} as never),
    offClick: chain({} as never),
  };

  const webApp = {
    initData: env.tgMockInitData,
    initDataUnsafe: {
      auth_date: Math.floor(Date.now() / 1000),
      hash: 'mock',
      signature: 'mock',
      user: {
        id: 1,
        first_name: 'Dev',
        username: 'dev_user',
      },
    },
    version: '8.0',
    platform: 'web',
    colorScheme: 'dark',
    themeParams: {},
    isExpanded: true,
    viewportHeight: window.innerHeight,
    viewportStableHeight: window.innerHeight,
    safeAreaInset: { top: 0, bottom: 0, left: 0, right: 0 },
    contentSafeAreaInset: { top: 0, bottom: 0, left: 0, right: 0 },
    isVersionAtLeast: () => true,
    ready: noop,
    expand: noop,
    close: noop,
    disableVerticalSwipes: noop,
    enableVerticalSwipes: noop,
    onEvent: noop,
    offEvent: noop,
    openLink: (url: string) => window.open(url, '_blank'),
    openTelegramLink: (url: string) => window.open(url, '_blank'),
    HapticFeedback: haptic,
    BackButton: button,
    MainButton: button,
  } as unknown as WebApp;

  window.Telegram = { WebApp: webApp } satisfies Telegram;
  console.warn('[telegram] подключена dev-заглушка window.Telegram.WebApp');
}
